import { useAppSelector } from '../../app/hooks';
import { selectPrimaryColor } from '../../app/slices/configuration.slice';

const WellDone = () => {
	const color = useAppSelector(selectPrimaryColor);

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 21.682 22">
			<path
				id="thumbs-up"
				d="M3,22a3,3,0,0,1-3-2.824L0,19V12A3,3,0,0,1,2.824,9L3,9H5.35L9.086.594A1,1,0,0,1,9.87.008L10,0a4,4,0,0,1,4,4h0V7h4.649a3,3,0,0,1,2.16.883h0l.138.148a3,3,0,0,1,.7,2.42h0l-1.38,9A3,3,0,0,1,17.28,22Zm2-2V11H3a1,1,0,0,0-.993.883L2,12v7a1,1,0,0,0,.883.993L3,20ZM10.607,2.094,7,10.21V20H17.291a1,1,0,0,0,.977-.74h0l.023-.112,1.38-9A1,1,0,0,0,18.66,9H13a1,1,0,0,1-1-1h0V4a2,2,0,0,0-1.287-1.869h0Z"
				fill={color}
			/>
		</svg>
	);
};

export default WellDone;
